import React from "react";

import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useHistory } from "react-router";

import { ReactComponent as ClickSvg } from "assets/images/homepage/click.svg";
import { ReactComponent as ComputerSelectTestSvg } from "assets/images/homepage/computer_select_test.svg";
import { ReactComponent as CreateAccountSvg } from "assets/images/homepage/create_account.svg";
import { ReactComponent as SampleAnalysisSvg } from "assets/images/homepage/sample_analysis.svg";

import { WorkflowStepItemProps } from "./type";
import { WorkflowStep } from "./WorkflowStep";

const WorkflowStepItems: WorkflowStepItemProps[] = [
  {
    title: "Create an account",
    content: "Sign in to get started with Assay Marketplace.",
    callToAction: "Sign Up Now",
    StepImage: CreateAccountSvg,
  },
  {
    title: "Select targets",
    content:
      "Submit your genes or fusions of interest to search our ever-expanding database of functionally tested primers.",
    StepImage: SampleAnalysisSvg,
  },
  {
    title: "Evaluate panel options",
    content:
      "Evaluate and compare our pre-designed modules and custom panels to find the one that best fits your needs.",
    StepImage: ComputerSelectTestSvg,
  },
  {
    title: "Request quote",
    content:
      "Once you've found the right panel, request a quote for our reagents.",
    StepImage: ClickSvg,
  },
];

export const WorkflowSteps = () => {
  const history = useHistory();

  return (
    <Box
      component="section"
      className="default-bg"
      pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
      pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
    >
      <Container>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          rowGap={4}
        >
          <Typography variant="h1" component="h2" align="center">
            How to Use the Assay Marketplace Website
          </Typography>
          <Grid container spacing={3} justifyContent="center" component="ul">
            {WorkflowStepItems.map(
              (item: WorkflowStepItemProps, index: number) => (
                <Grid item xs={12} sm={6} md={3} key={index} component="li">
                  <WorkflowStep {...item} />
                </Grid>
              )
            )}
          </Grid>
          <Button
            size="large"
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              const redirectUrl = "/catalog";
              event.ctrlKey
                ? window.open(redirectUrl, "_blank")
                : history.push(redirectUrl);
            }}
          >
            Browse catalog now
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
